export const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
  let z = t / (d / 2);
  if (z < 1) return (c / 2) * z * z + b;
  z -= 1;
  return (-c / 2) * (z * (z - 2) - 1) + b;
};

export const scrollTo = (element: HTMLElement, to: number, duration: number) => {
  if (!element) return;
  const start = element.scrollTop;
  const change = to - start;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
};
